(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pb-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pbCardInit) return;
    window.__pbCardInit = true;

    var imageCache = new Map();

    function preload(src) {
      if (!imageCache.has(src)) {
        imageCache.set(
          src,
          new Promise(function (resolve) {
            var img = new Image();
            img.src = src;
            if (img.decode) {
              img.decode().then(resolve, resolve);
            } else {
              img.onload = resolve;
              img.onerror = resolve;
            }
          })
        );
      }
      return imageCache.get(src);
    }

    // Swap is applied only after the target image is fully decoded, so the
    // paint is a single atomic frame: no flicker, no motion.
    function setImage(card, src) {
      var img = card.querySelector('[data-pb-card-img]');
      if (!img) return;
      if (!img.dataset.defaultSrc) {
        img.dataset.defaultSrc = img.getAttribute('src');
        img.dataset.defaultSrcset = img.getAttribute('srcset') || '';
      }
      card.__pbToken = (card.__pbToken || 0) + 1;
      var token = card.__pbToken;

      if (!src) {
        if (img.dataset.defaultSrcset) img.setAttribute('srcset', img.dataset.defaultSrcset);
        img.setAttribute('src', img.dataset.defaultSrc);
        return;
      }

      preload(src).then(function () {
        if (card.__pbToken !== token) return;
        img.removeAttribute('srcset');
        img.setAttribute('src', src);
      });
    }

    function revert(card) {
      var pressed = card.querySelector('[data-pb-swatch][aria-pressed="true"]');
      setImage(card, pressed ? pressed.dataset.image : null);
    }

    function warm(card) {
      if (card.dataset.pbWarmed) return;
      card.dataset.pbWarmed = 'true';
      card.querySelectorAll('[data-pb-swatch][data-image]').forEach(function (btn) {
        preload(btn.dataset.image);
      });
    }

    var hoverCapable = window.matchMedia('(hover: hover)').matches;

    // Warm the variant-image cache as soon as the pointer reaches a card.
    document.addEventListener(
      'pointerenter',
      function (event) {
        if (!(event.target instanceof Element)) return;
        var card = event.target.closest ? event.target.closest('[data-pb-card]') : null;
        if (card && event.target === card) warm(card);
      },
      true
    );
    document.addEventListener(
      'touchstart',
      function (event) {
        var card = event.target.closest && event.target.closest('[data-pb-card]');
        if (card) warm(card);
      },
      { capture: true, passive: true }
    );

    if (hoverCapable) {
      document.addEventListener(
        'mouseenter',
        function (event) {
          if (!(event.target instanceof Element)) return;
          if (!event.target.matches || !event.target.matches('[data-pb-swatch][data-image]')) return;
          var card = event.target.closest('[data-pb-card]');
          if (card) setImage(card, event.target.dataset.image);
        },
        true
      );
      document.addEventListener(
        'mouseleave',
        function (event) {
          if (!(event.target instanceof Element)) return;
          if (!event.target.matches || !event.target.matches('[data-pb-swatches]')) return;
          var card = event.target.closest('[data-pb-card]');
          if (card) revert(card);
        },
        true
      );
    }

    // Tap/click selects a swatch persistently (primary path on touch).
    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-pb-swatch]');
      if (!btn) return;
      event.preventDefault();
      var card = btn.closest('[data-pb-card]');
      if (!card) return;
      warm(card);
      var wasPressed = btn.getAttribute('aria-pressed') === 'true';
      card.querySelectorAll('[data-pb-swatch]').forEach(function (other) {
        other.setAttribute('aria-pressed', 'false');
      });
      if (wasPressed) {
        setImage(card, null);
      } else {
        btn.setAttribute('aria-pressed', 'true');
        if (btn.dataset.image) setImage(card, btn.dataset.image);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pb-product-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pbPdrInit) return;
    window.__pbPdrInit = true;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function parseColourMap(raw) {
      var map = {};
      if (!raw) return map;
      raw.split(/[,\n]+/).forEach(function (pair) {
        var i = pair.lastIndexOf(':');
        if (i < 1) return;
        var name = pair.slice(0, i).trim().toLowerCase();
        var hex = pair.slice(i + 1).trim();
        if (name && hex) map[name] = hex;
      });
      return map;
    }

    function getState(drawer) {
      if (drawer.__pbPdr) return drawer.__pbPdr;
      var dataEl = drawer.querySelector('[data-pb-pdr-data]');
      var products = {};
      try {
        products = JSON.parse(dataEl.textContent);
      } catch (e) {
        products = {};
      }
      /* per-product size guides pre-rendered in Liquid through the
         shared pb-size-guide snippet */
      var sizeTemplates = {};
      drawer.querySelectorAll('template[data-pb-pdr-sizeguide-for]').forEach(function (tpl) {
        sizeTemplates[tpl.getAttribute('data-pb-pdr-sizeguide-for')] = tpl;
      });
      var state = {
        products: products,
        sizeTemplates: sizeTemplates,
        colourMap: parseColourMap(drawer.getAttribute('data-colour-map')),
        sectionId: drawer.getAttribute('data-section-id') || '',
        currentId: null,
        product: null,
        colour: '',
        size: '',
        fadeSeq: 0,
        pendingId: null,
        pendingTimer: null,
        pendingRaf: null,
        scrollSeq: 0,
        els: {
          reveal: drawer.querySelector('[data-pb-pdr-reveal]'),
          inner: drawer.querySelector('[data-pb-pdr-inner]'),
          productInfo: drawer.querySelector('[data-pb-pdr-productinfo]'),
          gallery: drawer.querySelector('[data-pb-pdr-gallery]'),
          medialist: drawer.querySelector('[data-pb-pdr-medialist]'),
          variantSelects: drawer.querySelector('[data-pb-pdr-variantselects]'),
          variantIdInput: drawer.querySelector('[data-pb-pdr-variant-id]'),
          dots: drawer.querySelector('[data-pb-pdr-dots]'),
          name: drawer.querySelector('[data-pb-pdr-name]'),
          price: drawer.querySelector('[data-pb-pdr-price]'),
          colourBtn: drawer.querySelector('[data-pb-pdr-colour-btn]'),
          colourLabel: drawer.querySelector('[data-pb-pdr-colour-label]'),
          colourPanel: drawer.querySelector('[data-pb-pdr-colour-panel]'),
          colourWrap: drawer.querySelector('[data-pb-pdr-colour]'),
          swatchblock: drawer.querySelector('[data-pb-pdr-swatchblock]'),
          swatchname: drawer.querySelector('[data-pb-pdr-swatchname]'),
          swatches: drawer.querySelector('[data-pb-pdr-swatches]'),
          ordwrap: drawer.querySelector('[data-pb-pdr-ordwrap]'),
          ord: drawer.querySelector('[data-pb-pdr-ord]'),
          ordguide: drawer.querySelector('[data-pb-pdr-ordguide]'),
          stagelabel: drawer.querySelector('[data-pb-pdr-stagelabel]'),
          count: drawer.querySelector('[data-pb-pdr-count]'),
          stage: drawer.querySelector('.pb-pdr__stage'),
          prev: drawer.querySelector('[data-pb-pdr-prev]'),
          next: drawer.querySelector('[data-pb-pdr-next]'),
          guidebtn: drawer.querySelector('[data-pb-pdr-guidebtn]'),
          imagesbtn: drawer.querySelector('[data-pb-pdr-imagesbtn]'),
          atc: drawer.querySelector('[data-pb-pdr-atc]'),
          atcLabel: drawer.querySelector('[data-pb-pdr-atc] .atc__label'),
          error: drawer.querySelector('[data-pb-pdr-error]'),
          desc: drawer.querySelector('[data-pb-pdr-desc]'),
          tabbar: drawer.querySelector('[data-pb-pdr-tabbar]'),
          sizeTab: drawer.querySelector('[data-pb-pdr-sizetab]'),
          sizePane: drawer.querySelector('[data-pb-pdr-sizepane]'),
          tabs: drawer.querySelectorAll('[data-pb-pdr-tab]'),
          tabline: drawer.querySelector('[data-pb-pdr-tabline]'),
          tabpanes: drawer.querySelectorAll('[data-pb-pdr-tabpane]'),
        },
      };
      drawer.__pbPdr = state;
      wire(drawer, state);
      return state;
    }

    /* ---- chips ---- */

    function chipStyle(state, colour) {
      if (colour.hex) return 'background-color: ' + colour.hex + ';';
      if (colour.img) return "background-image: url('" + colour.img + "');";
      var mapped = state.colourMap[colour.name.trim().toLowerCase()];
      if (mapped) return 'background-color: ' + mapped + ';';
      return '';
    }

    function makeChip(state, colour) {
      var chip = document.createElement('span');
      chip.className = 'pb-pdr__chip';
      chip.setAttribute('aria-hidden', 'true');
      var style = chipStyle(state, colour);
      if (style) chip.setAttribute('style', style);
      return chip;
    }

    /* ---- colour dropdown ---- */

    function setColourPanel(state, open) {
      state.els.colourPanel.hidden = !open;
      state.els.colourBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function selectColour(state, name) {
      state.colour = name;
      var label = state.els.colourLabel;
      label.textContent = '';
      var colour = null;
      for (var i = 0; i < state.product.colors.length; i++) {
        if (state.product.colors[i].name === name) colour = state.product.colors[i];
      }
      if (colour) label.appendChild(makeChip(state, colour));
      var text = document.createElement('span');
      text.className = 'pb-pdr__field-label';
      text.textContent = name;
      label.appendChild(text);
      state.els.colourBtn.classList.add('has-value');
      state.els.colourPanel.querySelectorAll('[role="option"]').forEach(function (opt) {
        opt.setAttribute('aria-selected', opt.getAttribute('data-value') === name ? 'true' : 'false');
      });
      state.els.swatches.querySelectorAll('[role="option"]').forEach(function (opt) {
        opt.setAttribute('aria-selected', opt.getAttribute('data-value') === name ? 'true' : 'false');
      });
      state.els.swatchname.textContent = name;
      state.els.stagelabel.textContent = name;
      state.els.stagelabel.hidden = !name;
      setColourPanel(state, false);
      buildOrderTable(state);
      refreshAvailability(state);
      refreshGate(state);
      syncDawnVariant(state);
      setPrice(state);
      filterGalleryByColour(state);
    }

    /* SnapB2B price wrapper: point it at the current variant, reset the
       retail fallback (textContent also clears any injected span), and
       ask the app to rescan. It also watches the DOM, so the hooks are
       optional. */
    function setPrice(state) {
      var el = state.els.price;
      var product = state.product;
      var variant = variantFor(state, null) || product.variants[0];
      el.classList.remove('snap-b2b-processed');
      el.textContent = variant ? variant.price : product.price;
      el.setAttribute('snap-b2b-product-id', String(state.currentId));
      if (variant) el.setAttribute('snap-b2b-variant-id', String(variant.id));
      el.dispatchEvent(new CustomEvent('snap-b2b:refresh', { bubbles: true }));
      if (window.snapB2B && typeof window.snapB2B.refresh === 'function') {
        window.snapB2B.refresh();
      } else if (window.SnapB2B && typeof window.SnapB2B.init === 'function') {
        window.SnapB2B.init();
      }
    }

    function buildColours(state) {
      var panel = state.els.colourPanel;
      panel.textContent = '';
      state.product.colors.forEach(function (colour) {
        var opt = document.createElement('button');
        opt.type = 'button';
        opt.className = 'pb-pdr__colour-opt';
        opt.setAttribute('role', 'option');
        opt.setAttribute('aria-selected', 'false');
        opt.setAttribute('data-value', colour.name);
        opt.appendChild(makeChip(state, colour));
        var text = document.createElement('span');
        text.textContent = colour.name;
        opt.appendChild(text);
        panel.appendChild(opt);
      });
      state.els.colourWrap.style.display = state.product.colors.length ? '' : 'none';
      state.els.colourBtn.classList.remove('has-value');
      state.els.colourLabel.textContent = 'COLOUR';
      setColourPanel(state, false);

      /* desktop swatch row — same values, square chips */
      var row = state.els.swatches;
      row.textContent = '';
      state.product.colors.forEach(function (colour) {
        var opt = document.createElement('button');
        opt.type = 'button';
        opt.className = 'pb-pdr__swatch';
        opt.setAttribute('role', 'option');
        opt.setAttribute('aria-selected', 'false');
        opt.setAttribute('data-value', colour.name);
        opt.setAttribute('aria-label', colour.name);
        opt.appendChild(makeChip(state, colour));
        row.appendChild(opt);
      });
      state.els.swatchblock.style.display = state.product.colors.length ? '' : 'none';
      state.els.swatchname.textContent = '';
      state.els.stagelabel.hidden = true;
    }

    /* ---- Size · quantity order table ---- */

    function variantFor(state, size) {
      var p = state.product;
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (needsColour(state) && v.opts[p.colorPos - 1] !== state.colour) continue;
        if (size !== null && v.opts[p.sizePos - 1] !== size) continue;
        return v;
      }
      return null;
    }

    /* ---- Dawn-style variant-selects (Rubik Variant Images) ----
       A hidden proxy of the current product's options, kept in sync
       with our own swatches so the app embed can watch a Dawn-shaped
       selector + gallery. Rebuilt whenever the drawer switches
       product; the checked radios and the hidden id input are kept
       current whenever the colour changes. */

    function buildVariantSelects(state) {
      var root = state.els.variantSelects;
      root.textContent = '';
      var product = state.product;
      root.setAttribute('data-url', product.url);
      product.options.forEach(function (option, optIndex) {
        var fieldset = document.createElement('fieldset');
        fieldset.className = 'js product-form__input';
        var legend = document.createElement('legend');
        legend.textContent = option.name;
        fieldset.appendChild(legend);
        option.values.forEach(function (value, valIndex) {
          var id = 'pb-pdr-variant-' + state.sectionId + '-' + state.currentId + '-' + optIndex + '-' + valIndex;
          var input = document.createElement('input');
          input.type = 'radio';
          input.name = option.name;
          input.value = value;
          input.id = id;
          input.setAttribute('data-product-url', product.url);
          var label = document.createElement('label');
          label.setAttribute('for', id);
          label.textContent = value;
          fieldset.appendChild(input);
          fieldset.appendChild(label);
        });
        root.appendChild(fieldset);
      });
    }

    /* Checks each fieldset's radio to match the variant currently
       resolved for state.colour (any size), returning that variant. */
    function syncVariantRadios(state) {
      var variant = variantFor(state, null);
      var fieldsets = state.els.variantSelects.querySelectorAll('fieldset');
      fieldsets.forEach(function (fieldset, i) {
        var val = variant ? variant.opts[i] : null;
        fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
          input.checked = val !== null && input.value === val;
        });
      });
      return variant;
    }

    function syncDawnVariant(state) {
      if (!state.product || !state.product.options.length) return;
      var variant = syncVariantRadios(state);
      if (!variant) return;
      /* No change event on the radios: that sets off Dawn's product-info
         section fetch, whose late reply reorders the gallery and jumps to
         the variant's featured image. No ?variant= in the URL either. */
      state.els.variantIdInput.value = String(variant.id);
      document.dispatchEvent(
        new CustomEvent('variant:change', {
          detail: { variant: variant, sectionId: state.sectionId },
        })
      );
    }

    function stockText(v) {
      if (!v || !v.tracked || v.cont) return '';
      var q = Math.max(0, v.stock | 0);
      return q >= 5000 ? '5,000+' : q.toLocaleString('en-US');
    }

    function stockMax(v) {
      if (!v.tracked || v.cont) return 9999;
      return Math.max(0, v.stock | 0);
    }

    function buildOrderTable(state) {
      var ord = state.els.ord;
      ord.textContent = '';
      var sizes = state.product.sizes.length ? state.product.sizes : [null];
      ord.style.gridTemplateColumns = 'repeat(' + sizes.length + ', minmax(0, 1fr))';
      sizes.forEach(function (size) {
        var head = document.createElement('span');
        head.className = 'pb-pdr__ord-size';
        head.textContent = size === null ? 'QTY' : size;
        ord.appendChild(head);
      });
      sizes.forEach(function (size) {
        var v = variantFor(state, size);
        var dead = !v || !v.available;
        var input = document.createElement('input');
        input.className = 'pb-pdr__ord-cell';
        input.type = 'number';
        input.min = '0';
        input.inputMode = 'numeric';
        input.setAttribute('data-pb-ord-qty', '');
        if (v) input.setAttribute('data-variant-id', String(v.id));
        input.placeholder = dead ? '0' : stockText(v);
        input.disabled = dead;
        if (!dead) input.max = String(stockMax(v));
        input.setAttribute(
          'aria-label',
          (size === null ? 'Quantity' : 'Quantity, size ' + size) + (state.colour ? ', ' + state.colour : '')
        );
        ord.appendChild(input);
      });
    }

    function clampOrdInput(input) {
      var max = parseInt(input.max, 10);
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) {
        if (input.value !== '') input.value = '';
        return;
      }
      if (!isNaN(max) && val > max) input.value = String(max);
    }

    function orderItems(state) {
      var items = [];
      state.els.ord.querySelectorAll('[data-pb-ord-qty]').forEach(function (input) {
        var qty = parseInt(input.value, 10) || 0;
        var id = input.getAttribute('data-variant-id');
        if (qty > 0 && id) items.push({ id: parseInt(id, 10), quantity: qty });
      });
      return items;
    }

    /* ---- gallery + dots ---- */

    function buildGallery(state) {
      renderGallery(state, state.product.images);
    }

    /* One slide + one dot per image; the stage resets to the first. */
    function renderGallery(state, images) {
      var list = state.els.medialist;
      var dots = state.els.dots;
      list.textContent = '';
      dots.textContent = '';
      images.forEach(function (media, i) {
        var item = document.createElement('li');
        item.className = 'product__media-item';
        if (sideRank(normAlt(media.alt)) >= 2) {
          item.className += ' pb-pdr__media-item--bleed';
        }
        item.setAttribute('data-media-id', state.sectionId + '-' + media.id);
        var img = document.createElement('img');
        img.className = 'pb-pdr__img';
        img.src = media.src;
        img.alt = i === 0 ? state.product.title : '';
        img.loading = i === 0 ? 'eager' : 'lazy';
        item.appendChild(img);
        list.appendChild(item);
        var dot = document.createElement('span');
        dot.className = 'pb-pdr__dot' + (i === 0 ? ' is-active' : '');
        dots.appendChild(dot);
      });
      state.visibleImageCount = images.length;
      state.els.count.textContent = images.length ? '1 / ' + images.length : '';
      state.els.prev.hidden = images.length < 2;
      state.els.next.hidden = images.length < 2;
      state.els.gallery.scrollLeft = 0;
    }

    /* ---- colour filter from image alt text ----
       Alt format is COLOUR GARMENT SIDE ("HEATHER GREY TEE FRONT").
       An image belongs to the longest product colour found in its alt
       as a whole word/phrase; no match = no colour, never shown. */

    function normAlt(text) {
      return String(text || '').toUpperCase().replace(/\s+/g, ' ').trim();
    }

    function escapeRe(text) {
      return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function altColour(alt, colours) {
      var best = '';
      colours.forEach(function (name) {
        var key = normAlt(name);
        if (!key || key.length <= best.length) return;
        var re = new RegExp('(^|[^A-Z0-9])' + escapeRe(key) + '($|[^A-Z0-9])');
        if (re.test(alt)) best = key;
      });
      return best;
    }

    /* FRONT, BACK, DETAIL 1, DETAIL 2 ...; unrecognised sides last */
    function sideRank(alt) {
      if (/(^|\s)FRONT$/.test(alt)) return 0;
      if (/(^|\s)BACK$/.test(alt)) return 1;
      var m = alt.match(/(^|\s)DETAIL\s*(\d+)$/);
      if (m) return 2 + parseInt(m[2], 10);
      return Infinity;
    }

    function colourImages(state, colour) {
      var p = state.product;
      var names = p.colors.map(function (c) {
        return c.name;
      });
      var key = normAlt(colour);
      var matched = [];
      p.images.forEach(function (media, i) {
        var alt = normAlt(media.alt);
        if (altColour(alt, names) === key) {
          matched.push({ media: media, rank: sideRank(alt), index: i });
        }
      });
      matched.sort(function (a, b) {
        if (a.rank !== b.rank) return a.rank < b.rank ? -1 : 1;
        return a.index - b.index;
      });
      if (matched.length) {
        return matched.map(function (m) {
          return m.media;
        });
      }
      /* no alt text typed yet: the colour's first variant's featured
         image, else the product's first image, so the stage never
         goes blank */
      var featuredId = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].opts[p.colorPos - 1] === colour) {
          featuredId = p.variants[i].featured;
          break;
        }
      }
      for (var j = 0; featuredId && j < p.images.length; j++) {
        if (p.images[j].id === featuredId) return [p.images[j]];
      }
      return p.images.length ? [p.images[0]] : [];
    }

    function filterGalleryByColour(state) {
      if (!state.colour) {
        renderGallery(state, state.product.images);
        return;
      }
      renderGallery(state, colourImages(state, state.colour));
    }

    function stepGallery(state, dir) {
      var gallery = state.els.gallery;
      var w = gallery.clientWidth;
      if (!w) return;
      var i = Math.round(gallery.scrollLeft / w) + dir;
      var last = state.visibleImageCount ? state.visibleImageCount - 1 : 0;
      i = Math.max(0, Math.min(i, last));
      gallery.scrollTo({ left: i * w, behavior: reduced.matches ? 'auto' : 'smooth' });
    }

    function onGalleryScroll(state) {
      var gallery = state.els.gallery;
      var w = gallery.clientWidth;
      if (!w) return;
      var i = Math.round(gallery.scrollLeft / w);
      var dots = state.els.dots.children;
      for (var n = 0; n < dots.length; n++) {
        dots[n].classList.toggle('is-active', n === i);
      }
      var total = state.visibleImageCount || 0;
      if (total) state.els.count.textContent = Math.min(i + 1, total) + ' / ' + total;
    }

    /* ---- selection / gating / variant ---- */

    function needsColour(state) {
      return state.product.colors.length > 0;
    }

    /* An option value is unavailable when no purchasable variant
       (available === false only when inventory <= 0 AND the variant
       does not continue selling) carries it — filtered by whatever is
       already chosen on the other axis, so a dead combination can
       never be assembled. */
    /* A colour is unavailable when no purchasable variant carries it —
       it stays selectable in the UI so the table can show the sold-out
       row, but it is flagged visually. */
    function colourAvailable(state, value) {
      var p = state.product;
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (!v.available) continue;
        if (v.opts[p.colorPos - 1] === value) return true;
      }
      return false;
    }

    function refreshAvailability(state) {
      [state.els.colourPanel, state.els.swatches].forEach(function (scope) {
        scope.querySelectorAll('[role="option"]').forEach(function (opt) {
          var ok = colourAvailable(state, opt.getAttribute('data-value'));
          opt.setAttribute('aria-disabled', ok ? 'false' : 'true');
          opt.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function refreshGate(state) {
      state.els.atc.disabled = state.soldOut || orderItems(state).length === 0;
    }

    /* ---- tabs ---- */

    function setTab(state, key) {
      var tabs = state.els.tabs;
      /* underline position counts VISIBLE tabs only — with the middle
         Size Guide tab removed, Shipping & Returns is DOM index 2 but
         visible index 1 */
      var visIndex = 0;
      Array.prototype.forEach.call(tabs, function (tab) {
        var active = tab.getAttribute('data-pb-pdr-tab') === key;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        if (!tab.hidden) {
          if (active && state.els.tabline) {
            state.els.tabline.style.transform = 'translateX(' + visIndex * 100 + '%)';
          }
          visIndex++;
        }
      });
      Array.prototype.forEach.call(state.els.tabpanes, function (pane) {
        pane.classList.toggle('is-active', pane.getAttribute('data-pb-pdr-tabpane') === key);
      });
    }

    /* ---- populate / open / swap / close ---- */

    function populate(drawer, state, id) {
      var product = state.products[id];
      if (!product) return false;
      state.currentId = id;
      state.product = product;
      state.colour = '';
      state.els.name.textContent = product.title;
      setPrice(state);
      state.els.productInfo.setAttribute('data-url', product.url);
      buildGallery(state);
      buildColours(state);
      buildVariantSelects(state);
      state.els.desc.innerHTML = product.desc || '';
      buildSizeGuide(state);
      state.els.error.hidden = true;
      state.soldOut = true;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].available) {
          state.soldOut = false;
          break;
        }
      }
      state.els.atcLabel.textContent = state.soldOut ? 'Sold out' : 'ADD TO CART';
      setTab(state, 'description');

      /* preselect the darkest colour available — Black, else Carbon,
         else the first colour in Shopify's option order — same
         routine as a swatch tap, so the gallery opens already
         filtered */
      if (product.colors.length) {
        var first = product.colors[0].name;
        var darkPrefs = ['BLACK', 'CARBON'];
        var found = false;
        for (var d = 0; d < darkPrefs.length && !found; d++) {
          for (var c = 0; c < product.colors.length; c++) {
            if (normAlt(product.colors[c].name) === darkPrefs[d]) {
              first = product.colors[c].name;
              found = true;
              break;
            }
          }
        }
        selectColour(state, first);
      } else {
        buildOrderTable(state);
      }
      refreshAvailability(state);
      refreshGate(state);

      /* hook for gated add-ons (bulk order grid) — no listener, no-op */
      drawer.dispatchEvent(new CustomEvent('pb:pdr:populated', { detail: { id: id } }));
      return true;
    }

    /* Size Guide pane: clone the product's pre-rendered template
       (shared pb-size-guide markup). No template = no Size Guide tab —
       the bar shows two tabs and the underline width follows. */
    function buildSizeGuide(state) {
      var tpl = state.sizeTemplates[String(state.currentId)];
      var pane = state.els.sizePane;
      pane.textContent = '';
      state.els.sizeTab.hidden = !tpl;
      state.els.ordguide.hidden = !tpl;
      state.els.guidebtn.hidden = !tpl;
      state.els.tabbar.classList.toggle('is-two', !tpl);
      if (tpl) pane.appendChild(tpl.content.cloneNode(true));
    }

    /* Scroll the opened drawer into full view: its top lands just under
       the sticky header. The drawer is in flow and expands downward, so
       the target position is stable even while the 450ms reveal runs. */
    function anchorDrawer(drawer) {
      var header = document.querySelector('.pb-header');
      var offset = header ? header.offsetHeight : 0;
      var top = drawer.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top: top, behavior: reduced.matches ? 'auto' : 'smooth' });
    }

    /* Keeps each card's "+" (View details) button in sync with which
       product is open OR mid-sequence (turned already, still waiting
       on the delay/scroll before the drawer actually opens — see
       state.pendingId in openDrawer) in this drawer — aria-expanded
       true for exactly one card, so the icon's rotate-to-X CSS (keyed
       off aria-expanded) and screen readers agree with the drawer
       regardless of which route opened/closed/swapped it. */
    function syncCardToggles(drawer, state) {
      var section = drawer.closest('.pb-showcase-section') || drawer.closest('.shopify-section');
      if (!section) return;
      var isOpen = drawer.classList.contains('is-open');
      section.querySelectorAll('[data-pb-card]').forEach(function (card) {
        var btn = card.querySelector('.pb-card__quick-btn');
        if (!btn) return;
        var active =
          (isOpen && card.dataset.productId === state.currentId) || card.dataset.productId === state.pendingId;
        btn.setAttribute('aria-expanded', active ? 'true' : 'false');
      });
    }

    /* Clears whatever's in flight for a staged open — the delay timer,
       the scroll animation's frame, and the "turned but not open yet"
       marker — so a second tap (a different card, or the drawer
       closing outright) can't have the original sequence land late and
       open the wrong product. */
    function cancelPendingSequence(state) {
      if (state.pendingTimer) {
        window.clearTimeout(state.pendingTimer);
        state.pendingTimer = null;
      }
      if (state.pendingRaf) {
        window.cancelAnimationFrame(state.pendingRaf);
        state.pendingRaf = null;
      }
      state.scrollSeq = (state.scrollSeq || 0) + 1;
      state.pendingId = null;
    }

    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    /* Same target anchorDrawer has always scrolled to, just animated
       over a settings-driven duration instead of native smooth scroll
       (browsers don't expose a way to set that duration). */
    function animateScrollToDrawer(drawer, state, onDone) {
      var header = document.querySelector('.pb-header');
      var offset = header ? header.offsetHeight : 0;
      var target = drawer.getBoundingClientRect().top + window.scrollY - offset;
      var start = window.scrollY;
      var change = target - start;
      var duration = parseInt(drawer.dataset.scrollDuration, 10) || 800;
      var seq = ++state.scrollSeq;
      var startTime = null;

      if (!change) {
        onDone();
        return;
      }

      function step(timestamp) {
        if (seq !== state.scrollSeq) return;
        if (startTime === null) startTime = timestamp;
        var t = Math.min((timestamp - startTime) / duration, 1);
        window.scrollTo(0, start + change * easeInOutQuad(t));
        if (t < 1) {
          state.pendingRaf = window.requestAnimationFrame(step);
        } else {
          state.pendingRaf = null;
          onDone();
        }
      }

      state.pendingRaf = window.requestAnimationFrame(step);
    }

    /* The existing open — populate + reveal, or the fade-swap when a
       different product replaces one already open. No scrolling here;
       by the time this runs the page is already at the drawer. colour,
       when given (a card swatch tap rather than the plus/image),
       overrides populate()'s own Black/Carbon default once the product
       is loaded. */
    function commitOpen(drawer, state, id, colour) {
      var isOpen = drawer.classList.contains('is-open');
      state.pendingId = null;

      if (isOpen && state.currentId === id) {
        syncCardToggles(drawer, state);
        return;
      }
      if (!isOpen) {
        if (populate(drawer, state, id)) {
          drawer.classList.add('is-open');
          if (colour) selectColour(state, colour);
        }
        syncCardToggles(drawer, state);
        return;
      }
      if (reduced.matches) {
        populate(drawer, state, id);
        if (colour) selectColour(state, colour);
        syncCardToggles(drawer, state);
        return;
      }
      var seq = ++state.fadeSeq;
      state.els.inner.classList.add('is-out');
      window.setTimeout(function () {
        if (seq !== state.fadeSeq) return;
        populate(drawer, state, id);
        if (colour) selectColour(state, colour);
        state.els.inner.classList.remove('is-out');
        syncCardToggles(drawer, state);
      }, 300);
    }

    /* Staged: the plus turns immediately (via syncCardToggles picking
       up state.pendingId), then — after open_delay — the page glides
       to the drawer over scroll_duration, and only once that settles
       does the drawer actually open. Reduced motion skips straight to
       an instant jump + open. colour is passed straight through to
       commitOpen for a card swatch tap; plus/image taps omit it, so
       the default colour populate() picks stays unchanged for them. */
    function openDrawer(drawer, state, id, colour) {
      var isOpen = drawer.classList.contains('is-open');
      if (isOpen && state.currentId === id) return;

      cancelPendingSequence(state);
      state.pendingId = id;
      syncCardToggles(drawer, state);

      if (reduced.matches) {
        anchorDrawer(drawer);
        commitOpen(drawer, state, id, colour);
        return;
      }

      var openDelay = parseInt(drawer.dataset.openDelay, 10) || 0;
      state.pendingTimer = window.setTimeout(function () {
        state.pendingTimer = null;
        animateScrollToDrawer(drawer, state, function () {
          commitOpen(drawer, state, id, colour);
        });
      }, openDelay);
    }

    function closeDrawer(drawer, state) {
      cancelPendingSequence(state);
      state.fadeSeq++;
      state.els.inner.classList.remove('is-out');
      drawer.classList.remove('is-open');
      setColourPanel(state, false);
      syncCardToggles(drawer, state);
    }

    /* ---- add to cart -> existing theme cart drawer ---- */

    function addToCart(state) {
      var atc = state.els.atc;
      if (atc.disabled || atc.getAttribute('aria-busy') === 'true') return;

      function fail(message) {
        state.els.error.textContent = message;
        state.els.error.hidden = false;
      }

      var items = orderItems(state);
      if (!items.length) {
        fail('Enter a quantity first.');
        return;
      }

      atc.setAttribute('aria-busy', 'true');
      atc.classList.add('is-loading');
      atc.disabled = true;
      state.els.error.hidden = true;

      var atcGeneration = (state.atcGeneration = (state.atcGeneration || 0) + 1);
      var atcTimeout = window.setTimeout(function () {
        if (state.atcGeneration !== atcGeneration) return;
        atc.classList.remove('is-loading');
        atc.removeAttribute('aria-busy');
        refreshGate(state);
      }, 8000);

      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: items,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) {
              fail(data.description || data.message || 'Something went wrong — please try again.');
              return;
            }
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && data.sections) {
              cartDrawer.renderContents({
                id: data.items && data.items[0] && data.items[0].id,
                sections: data.sections,
              });
            }
            state.els.ord.querySelectorAll('[data-pb-ord-qty]').forEach(function (input) {
              input.value = '';
            });
            refreshGate(state);
          });
        })
        .catch(function () {
          fail('Something went wrong — please try again.');
        })
        .finally(function () {
          window.clearTimeout(atcTimeout);
          atc.classList.remove('is-loading');
          atc.removeAttribute('aria-busy');
          refreshGate(state);
        });
    }

    /* ---- events ---- */

    function wire(drawer, state) {
      drawer.querySelector('[data-pb-pdr-close]').addEventListener('click', function () {
        closeDrawer(drawer, state);
      });

      state.els.gallery.addEventListener(
        'scroll',
        function () {
          if (state.__scrollRaf) return;
          state.__scrollRaf = window.requestAnimationFrame(function () {
            state.__scrollRaf = 0;
            onGalleryScroll(state);
          });
        },
        { passive: true }
      );

      state.els.colourBtn.addEventListener('click', function () {
        setColourPanel(state, state.els.colourPanel.hidden);
      });

      state.els.colourPanel.addEventListener('click', function (event) {
        var opt = event.target.closest('[role="option"]');
        if (opt) selectColour(state, opt.getAttribute('data-value'));
      });

      state.els.swatches.addEventListener('click', function (event) {
        var opt = event.target.closest('[role="option"]');
        if (opt) selectColour(state, opt.getAttribute('data-value'));
      });

      state.els.ord.addEventListener('input', function (event) {
        var input = event.target.closest('[data-pb-ord-qty]');
        if (!input) return;
        clampOrdInput(input);
        refreshGate(state);
      });

      function showSizeGuide() {
        setTab(state, 'sizeguide');
        state.els.tabbar.scrollIntoView({
          behavior: reduced.matches ? 'auto' : 'smooth',
          block: 'nearest',
        });
      }
      state.els.ordguide.addEventListener('click', showSizeGuide);
      state.els.guidebtn.addEventListener('click', showSizeGuide);

      state.els.prev.addEventListener('click', function () {
        stepGallery(state, -1);
      });

      state.els.next.addEventListener('click', function () {
        stepGallery(state, 1);
      });

      state.els.imagesbtn.addEventListener('click', function () {
        state.els.stage.scrollIntoView({
          behavior: reduced.matches ? 'auto' : 'smooth',
          block: 'start',
        });
      });

      state.els.atc.addEventListener('click', function () {
        addToCart(state);
      });

      Array.prototype.forEach.call(state.els.tabs, function (tab) {
        tab.addEventListener('click', function () {
          setTab(state, tab.getAttribute('data-pb-pdr-tab'));
        });
      });
    }

    /* Card tap anywhere opens the drawer of its own section. The "+"
       and the image are both toggles sharing this one handler: tapping
       either while the drawer is already open for this card's product
       closes it instead. A swatch tap runs the same staged open with
       that colour, unless the drawer's already open on this card's
       product, in which case it just swaps the colour in place — no
       close, no scroll. Swatches keep their own image-swap/aria-pressed
       behaviour (separate handler in pb-product-card.liquid); the
       slider drag-suppression click never reaches here (capture +
       stop). */
    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var card = event.target.closest('[data-pb-card]');
      if (!card || !card.dataset.productId) return;
      var section = card.closest('.pb-showcase-section') || card.closest('.shopify-section');
      var drawer = section && section.querySelector('[data-pb-pdr]');
      if (!drawer) return;
      var state = getState(drawer);
      var isOpenForThisCard = drawer.classList.contains('is-open') && state.currentId === card.dataset.productId;

      var swatch = event.target.closest('[data-pb-swatch]');
      if (swatch) {
        var colour = swatch.dataset.colour || '';
        if (isOpenForThisCard) {
          if (colour) selectColour(state, colour);
        } else {
          openDrawer(drawer, state, card.dataset.productId, colour);
        }
        return;
      }

      var isToggleTrigger = !!event.target.closest('.pb-card__quick-btn, .pb-card__img-btn');
      if (isToggleTrigger && isOpenForThisCard) {
        closeDrawer(drawer, state);
      } else {
        openDrawer(drawer, state, card.dataset.productId);
      }
    });

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      document.querySelectorAll('[data-pb-pdr]').forEach(function (drawer) {
        var state = drawer.__pbPdr;
        if (!state || state.els.colourPanel.hidden) return;
        if (!event.target.closest('[data-pb-pdr-colour]')) setColourPanel(state, false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-pb-pdr]').forEach(function (drawer) {
        var state = drawer.__pbPdr;
        if (state && !state.els.colourPanel.hidden) setColourPanel(state, false);
      });
    });

    /* Static mode (product page): no card to tap, so populate and open
       straight away. No delay, no scroll, no animation. */
    function initStatic() {
      document.querySelectorAll('[data-pb-pdr][data-pb-pdr-static]').forEach(function (drawer) {
        if (drawer.classList.contains('is-open')) return;
        var state = getState(drawer);
        if (populate(drawer, state, drawer.getAttribute('data-pb-pdr-static'))) {
          drawer.classList.add('is-open');
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStatic);
    } else {
      initStatic();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pb-product-slider"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pbSliderInit) return;
    window.__pbSliderInit = true;

    var state = null;

    document.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      var track = event.target.closest && event.target.closest('[data-pb-slider-track]');
      if (!track) return;
      state = {
        track: track,
        startX: event.clientX,
        startScroll: track.scrollLeft,
        dragged: false,
      };
    });

    document.addEventListener('pointermove', function (event) {
      if (!state) return;
      var dx = event.clientX - state.startX;
      if (!state.dragged && Math.abs(dx) > 6) {
        state.dragged = true;
        state.track.classList.add('is-dragging');
        state.track.setPointerCapture && state.track.setPointerCapture(event.pointerId);
      }
      if (state.dragged) {
        state.track.scrollLeft = state.startScroll - dx;
        event.preventDefault();
      }
    });

    function endDrag() {
      if (!state) return;
      var track = state.track;
      var dragged = state.dragged;
      state = null;
      if (!dragged) return;
      // Suppress the click that follows a drag so cards/swatches don't fire.
      track.addEventListener(
        'click',
        function (clickEvent) {
          clickEvent.stopPropagation();
          clickEvent.preventDefault();
        },
        { capture: true, once: true }
      );
      requestAnimationFrame(function () {
        track.classList.remove('is-dragging');
      });
    }

    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);
  })();
  } catch(e) { console.error(e); }
})();

})();
